import styled from 'styled-components'
import rem from '../../../../styles/tools/rem'

import { txt16OpenSans } from '../../../../styles/settings/types'
import { darkSlateBlue, paleGray } from '../../../../styles/settings/colors'

export const ShowResultsFormWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`

export const ShowResultsInput = styled.input`
  border: none;
  border-bottom: 3px solid ${darkSlateBlue};
  background-color: ${paleGray};
  padding: ${rem('16px')};
  line-height: ${rem('24px')};
  color: ${darkSlateBlue};
  ${txt16OpenSans};
  width: 100%;
  margin: 0 ${rem('10px')};
  &:first-of-type {
    margin: 0;
    margin-right: ${rem('10px')};
  }
  &:last-of-type {
    margin: 0;
    margin-left: ${rem('10px')};
  }
`



// WEBPACK FOOTER //
// ./src/app/pages/DashboardStatement/ShowResults/styles.js